import type { ModelCatalogEntry } from '../types';

interface ModelSelectorProps {
  models: ModelCatalogEntry[];
  selectedModelId: string | null;
  onChange: (modelId: string) => void;
  disabled?: boolean;
  error?: string | null;
}

export default function ModelSelector({
  models,
  selectedModelId,
  onChange,
  disabled = false,
  error = null,
}: ModelSelectorProps) {
  if (error !== null) {
    return (
      <div
        className="model-selector model-selector-error"
        role="alert"
        aria-invalid="true"
      >
        {error}
      </div>
    );
  }

  return (
    <div className="model-selector">
      <label htmlFor="model-select" className="model-selector-label">
        Model
      </label>
      <select
        id="model-select"
        value={selectedModelId ?? ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        aria-label="Model"
      >
        {models.map((m) => (
          <option key={m.modelId} value={m.modelId}>
            {m.displayName}
          </option>
        ))}
      </select>
    </div>
  );
}
